/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：289
 */

module.exports = {
  hide: "style_hide__3X1wf",
  "coco-widget-wrapper": "style_coco-widget-wrapper__3FasJ",
  "coco-child-widget": "style_coco-child-widget__94CqK",
  "coco-child-widget-selected": "style_coco-child-widget-selected__ebb2V",
  "coco-child-widget-full": "style_coco-child-widget-full__3SA0n",
  checkboxWidget: "style_checkboxWidget__2oVjp",
  headline: "style_headline__23it4",
  defaultCheckbox: "style_defaultCheckbox__knFEd",
  inner: "style_inner__2xD53",
  selected: "style_selected__2-LyX",
  checkboxSelected: "style_checkboxSelected__20TAs"
}
